import React from 'react';
import toast from 'react-hot-toast';
import { Copy, Link2, Printer } from 'lucide-react';
import { copyText } from '../../utils/publicStatus';
import { printPublicReceipt, publicConsultaUrl } from '../../utils/publicReceipt';

const PublicResultActions = ({
  protocol,
  sharePath,
  shareParam,
  receipt,
}) => {
  if (!protocol) return null;

  return (
    <div className="flex flex-wrap gap-2">
      <button
        type="button"
        className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium text-primary-800 ring-1 ring-primary-200 hover:bg-primary-50"
        onClick={async () => {
          const ok = await copyText(protocol);
          toast[ok ? 'success' : 'error'](ok ? 'Número copiado.' : 'Não foi possível copiar.');
        }}
      >
        <Copy className="h-3.5 w-3.5" aria-hidden />
        Copiar número
      </button>
      <button
        type="button"
        className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium text-slate-700 ring-1 ring-slate-200 hover:bg-slate-50"
        onClick={async () => {
          const url = publicConsultaUrl(sharePath, shareParam, protocol);
          const ok = await copyText(url);
          toast[ok ? 'success' : 'error'](ok ? 'Link da consulta copiado.' : 'Não foi possível copiar o link.');
        }}
      >
        <Link2 className="h-3.5 w-3.5" aria-hidden />
        Copiar link
      </button>
      <button
        type="button"
        className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium text-slate-700 ring-1 ring-slate-200 hover:bg-slate-50"
        onClick={() => {
          const ok = printPublicReceipt(receipt);
          if (!ok) toast.error('Permita pop-ups para imprimir o comprovante.');
        }}
      >
        <Printer className="h-3.5 w-3.5" aria-hidden />
        Imprimir
      </button>
    </div>
  );
};

export default PublicResultActions;
